<div class="client-error">
    <div class="body-container body-container--min-height">
        <div class="body-container">
            <!--<img src="assets/img/client-error.svg" alt="client-error-img">-->
            <img src="../../../assets/img/error_404.svg">
        </div>
        <div>
            <p style="color: #171C8F; font-family: 'TradeGothic_LT_Bold'; font-size: 24px;">
                Page not found
            </p>
        </div>
        <div>
            <span class="info" style="font-family: 'HelveticaNeue'; font-size: 16px;">
                <!--This page does not exist. <span class="link" (click)="home()">Return to Home Page</span>-->
                <!--You are trying to access an unauthorized page.  <span class="link" (click)="home()">Return to Login Page</span>-->
                You are trying to access an unauthorized page.
            </span>
        </div>
    </div>
</div>